import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
export var POSTestimonialType;
(function(POSTestimonialType) {
    POSTestimonialType["SAVE_TIME"] = "SAVE_TIME";
    POSTestimonialType["FLEXIBLE_SETTINGS"] = "FLEXIBLE_SETTINGS";
})(POSTestimonialType || (POSTestimonialType = {}));
export var POSTestimonialSection = function(param) {
    var testimonialTypes = param.testimonialTypes, backgroundColor = param.backgroundColor;
    var isMobile = useViewport().isMobile;
    var testimonials = testimonialTypes.map(getTestimonialByType);
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Section, {
            color: backgroundColor,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "displaySSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "kvCnON",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "What retailers are saying"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(Column, {
                    gap: "4x",
                    children: testimonials.map(function(t, index) {
                        return /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsxs(Typography, {
                                    children: [
                                        '"',
                                        t.testimony,
                                        '"'
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "2x"
                                }),
                                /*#__PURE__*/ _jsxs(Row, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Avatar, {
                                            image: t.avatarImage,
                                            userName: t.authorName,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "1x"
                                        }),
                                        /*#__PURE__*/ _jsxs(Column, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    children: t.authorName
                                                }),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "labelSansRegular",
                                                    children: t.retailerName
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Section, {
        color: backgroundColor,
        children: [
            testimonials.map(function(t, index) {
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            align: "center",
                            variant: "displayXLSerifRegular",
                            style: {
                                marginBottom: getSpacing("-4x")
                            },
                            children: "“"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            align: "center",
                            variant: "pageHeaderSerifRegular",
                            children: t.testimony
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "3x"
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            align: "center",
                            justify: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    image: t.avatarImage,
                                    userName: t.authorName,
                                    size: "small"
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "2x"
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subheadingSansRegular",
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "FqY7ry",
                                        defaultMessage: [
                                            {
                                                type: 1,
                                                value: "retailerPersonName"
                                            },
                                            {
                                                type: 0,
                                                value: ", "
                                            },
                                            {
                                                type: 1,
                                                value: "retailerCompanyName"
                                            }
                                        ],
                                        values: {
                                            retailerPersonName: t.authorName,
                                            retailerCompanyName: t.retailerName
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "10x",
                    desktopAndAbove: 120
                }
            })
        ]
    });
};
var getTestimonialByType = function(type) {
    switch(type){
        case POSTestimonialType.SAVE_TIME:
            return {
                authorName: "Kelsey",
                retailerName: "Green Roost",
                testimony: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "fQl4oH",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Faire POS integration has been key to streamlining the backend of my business. It saves us tons of time and effort when creating new items in my POS."
                        }
                    ]
                }),
                avatarImage: IImage.build({
                    url: "https://cdn.faire.com/fastly/212e6e150d0235610100a23a7ea6fbafcd6ddbcb25a45affd0b6624b4cb3c77c.png"
                })
            };
        case POSTestimonialType.FLEXIBLE_SETTINGS:
            return {
                authorName: "Julie",
                retailerName: "Offbeat Co.",
                testimony: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "CKqmwR",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "My experience with the integration syncing products directly into my POS has been wonderful. I can customize information as I need, but otherwise it\u2019s just a few clicks to get my products ready to go live on my POS."
                        }
                    ]
                }),
                avatarImage: IImage.build({
                    url: "https://cdn.faire.com/fastly/19fc734b9d3b07b6b6f919e137db7b26711f4d26963ad3b8aad584a77579335b.png"
                })
            };
    }
};
